import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollRestoration from '../../shared/components/ScrollRestoration';
import App from './App';

class Root extends PureComponent {
    static propTypes = {
        store: PropTypes.object.isRequired
    };

    render() {
        const { store, authContext = {} } = this.props;

        return (
            <Provider store={store}>
                <Router basename="/paths">
                    <ScrollRestoration>
                        <App store={store} authContext={authContext}/>
                    </ScrollRestoration>
                </Router>
            </Provider>
        );
    }
}

export default Root;
